const truncateText = (text: string, maxLength: number = 500) => {
  if (text.length <= maxLength) {
    return text;
  }

  const truncatedText = text.slice(0, maxLength - 3);
  const lastSpaceIndex = truncatedText.lastIndexOf(" ");
  return `${truncatedText.slice(0, lastSpaceIndex)}...`;
};

export default truncateText;
